import React from 'react';
import './styles.scoped.scss';
import JSONPretty from 'react-json-pretty';
import Modal from 'react-bootstrap/Modal';
import { FaRegCopy, FaTimes } from 'react-icons/fa';
import clipboardCopy from 'clipboard-copy';
import { notification } from '../../../../../assets/constants/strings';
const JSONPrettyMon = require('react-json-pretty/dist/monikai');

/**
 * Full-screen view of the response. Mirrors the inline panel's language — a
 * dark terminal bar carrying the same status pill / method+url / timing and a
 * copy action, over the same #0a1c33 JSON console — so expanding feels like the
 * same surface, just bigger.
 */
const ModalResponse = ({ show, handleClose, responseData, meta }) => {
  const copyResponse = () => {
    clipboardCopy(JSON.stringify(responseData, null, 2))
      .then(() => notification('success', 'Response copied to clipboard.'))
      .catch(() => notification('info', 'Could not copy the response.'));
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='xl'
      centered
      scrollable
      dialogClassName='expl-resp-modal'
    >
      <div className='expl-resp-modal__bar'>
        <div className='expl-resp-modal__meta'>
          {meta && (
            <span
              className={`expl-resp-modal__status ${
                meta.ok ? 'is-ok' : 'is-fail'
              }`}
            >
              {meta.ok ? 'Success' : 'Failed'}
            </span>
          )}
          {meta && (
            <code className='expl-resp-modal__url'>
              {meta.method} {meta.url}
            </code>
          )}
          {meta && typeof meta.durationMs === 'number' && (
            <span className='expl-resp-modal__time'>{meta.durationMs} ms</span>
          )}
        </div>
        <div className='expl-resp-modal__actions'>
          <button
            type='button'
            className='expl-resp-modal__act'
            title='Copy response'
            onClick={copyResponse}
          >
            <FaRegCopy /> Copy
          </button>
          <button
            type='button'
            className='expl-resp-modal__act expl-resp-modal__act--close'
            title='Close'
            aria-label='Close'
            onClick={handleClose}
          >
            <FaTimes />
          </button>
        </div>
      </div>
      <Modal.Body>
        <JSONPretty
          data={responseData}
          theme={JSONPrettyMon}
          className='customJSON'
        ></JSONPretty>
      </Modal.Body>
    </Modal>
  );
};

export default ModalResponse;
